import React, { useState, useEffect, useRef, Component } from "react";
import { useAuth } from "../contexts/AuthContext";
import {
  AccordionTitle,
  AccordionContent,
  Accordion,
  Container,
  Dimmer,
  Grid,
  GridRow,
  GridColumn,
  Form,
  Select,
  Input,
  FormInput,
  TabPane,
  Tab,
  Button,
  TextArea,
  Checkbox,
  Icon,
  Segment,
  Label,
  Search,
  ButtonGroup,
  Menu,
  Loader,
} from "semantic-ui-react";
import "../scss/common.scss";
import { ReactComponent as IconImage } from "../assets/images/icon-img.svg";
import "lightbox2/dist/css/lightbox.css";
import "lightbox2/dist/js/lightbox-plus-jquery.js";
import InputComponent from "../components/InputComponent";
import TabComponent from "../components/TabComponent";

// チートシートクラス
class MenuExampleTabularOnLeft extends Component {
  // テンプレート用のデータ
  state = {
    activeItem: "イントラ給与",
    data: {
      イントラ給与: [
        "2024-04-01,インストラクターA,99999,人件費(イントラ),振込",
        "2024-04-01,インストラクターB,99999,人件費(イントラ),振込",
        "2024-04-01,インストラクターC,99999,人件費(イントラ),振込",
      ],
      社員給与: [
        "2024-04-01,社員A,99999,人件費(社員),振込",
        "2024-04-01,社員B,99999,人件費(社員),振込",
        "2024-04-01,社員C,99999,人件費(社員),振込",
      ],
      レンタルスタジオ: [
        "2024-04-01,オカモト ミカ,32016,レンタルスタジオ,振込",
        "2024-04-01,カナマル ナルミ,24500,レンタルスタジオ,振込",
        "2024-04-01,カワムラ ユカ,28000,レンタルスタジオ,振込",
        "2024-04-01,クドウ ユメ,11000,レンタルスタジオ,振込",
        "2024-04-01,クリエントランス,18000,レンタルスタジオ,振込",
        "2024-04-01,カ)グランジュテ,29920,レンタルスタジオ,振込",
        "2024-04-01,シービーダンスアート,33000,レンタルスタジオ,振込",
        "2024-04-01,シラカワ チホ,12000,レンタルスタジオ,振込",
        "2024-04-01,ジャストカーズ テンシヨウ タカノブ,29100,レンタルスタジオ,振込",
        "2024-04-01,スタジオ ビッグ トゥリー ササキ ヒロキ,70000,レンタルスタジオ,振込",
        "2024-04-01,スタジオミゲロン ロペス ゴメス ミゲル アンヘル,27600,レンタルスタジオ,振込",
        "2024-04-01,ユ)セブンプロジエクト,31680,レンタルスタジオ,振込",
        "2024-04-01,タダ ノブユキ,35200,レンタルスタジオ,振込",
        "2024-04-01,カ)テイショウビジョン,19800,レンタルスタジオ,振込",
        "2024-04-01,ユ)バクサム,24000,レンタルスタジオ,振込",
        "2024-04-01,ヒキ コウヘイ,19800,レンタルスタジオ,振込",
        "2024-04-01,ヒトスギ アヤカ,17920,レンタルスタジオ,振込",
        "2024-04-01,ヒロノタダトシ,34000,レンタルスタジオ,振込",
        "2024-04-01,ビ-チタウン,29700,レンタルスタジオ,振込",
        "2024-04-01,ユ)ピー.ワイ.ツー,20000,レンタルスタジオ,振込",
        "2024-04-01,カ)フェニックス アカデミー,28800,レンタルスタジオ,振込",
        "2024-04-01,マエダダンスカンパニー ダイヒョウ マエダ マサヒ,30000,レンタルスタジオ,振込",
        "2024-04-01,ユ) ヤチヨショウジ,19000,レンタルスタジオ,振込",
        "2024-04-01,ヨクラ トミヒロ,26400,レンタルスタジオ,振込",
        "2024-04-01,リード クリエーション(カ,14400,レンタルスタジオ,振込",
        "2024-04-01,カ)リープスター,39600,レンタルスタジオ,振込",
        "2024-04-01,リボアップ タカハシ コウイチロウ,36000,レンタルスタジオ,振込",
      ],
    },
  };

  handleItemClick = (e, { name }) => this.setState({ activeItem: name });

  render() {
    const { activeItem, data } = this.state;

    return (
      // https://react.semantic-ui.com/collections/menu/#types-tabular-on-left
      <Grid>
        <GridColumn width={4}>
          <div className="scroll-y">
            <Menu fluid vertical tabular className="mini">
              <Menu.Item
                name="イントラ給与"
                active={activeItem === "イントラ給与"}
                onClick={this.handleItemClick}
              />
              <Menu.Item
                name="社員給与"
                active={activeItem === "社員給与"}
                onClick={this.handleItemClick}
              />
              <Menu.Item
                name="レンタルスタジオ"
                active={activeItem === "レンタルスタジオ"}
                onClick={this.handleItemClick}
              />
            </Menu>
          </div>
        </GridColumn>

        <GridColumn stretched width={12}>
          <Segment className="mini" style={{ textAlign: "left" }}>
            {data[activeItem].map((item, index) => (
              <React.Fragment key={index}>
                {item}
                <br />
              </React.Fragment>
            ))}
          </Segment>
        </GridColumn>
      </Grid>
    );
  }
}
// チートシートクラスここまで

function TradePage() {
  // ユーザーID
  const { userId } = useAuth();
  // 取引先
  const [counterparty, setCounterparty] = useState("");
  // 取引情報
  const [trades, setTrades] = useState([]);
  // 重複リスト
  const [duplicateTrades, setDuplicateTrades] = useState([]);

  // 編集、削除用のオブジェクト
  const [editedTrades, setEditedTrades] = useState({});

  // ログ
  const [logs, setLogs] = useState([]);

  // 取引先リスト
  const [companies, setCompanies] = useState([]);

  // フィルタリングした取引先リスト
  const [filteredCompanyNames, setFilteredCompanyNames] = useState([]);

  // フィルター
  const [startDateFilter, setStartDateFilter] = useState(""); // 開始日付
  const [endDateFilter, setEndDateFilter] = useState(""); // 終了日付
  const [counterpartyFilter, setCounterpartyFilter] = useState(""); // 取引先
  const [amountFilter, setAmountFilter] = useState(""); // 金額
  const [categoryFilter, setCategoryFilter] = useState([]); // カテゴリー
  const [paymentMethodFilter, setPaymentMethodFilter] = useState([]); // 決済手段
  const [tradeIdFilter, setTradeIdFilter] = useState(""); // ID
  // ソート
  const [counterpartySort, setCounterpartySort] = useState(""); // 取引先
  const [dateSort, setDateSort] = useState(""); // 日付
  const [amountSort, setAmountSort] = useState(""); // 金額
  const [settlementSort, setSettlementSort] = useState(""); // 立替精算
  const [tradeIdSort, setTradeIdSort] = useState(""); // ID

  const [activeIndex, setActiveIndex] = useState(-1);

  const [page, setPage] = useState(1); // ページ番号

  // 日付
  const [loadingStatus, setLoadingStatus] = useState(false);

  // 編集中のオブジェクト
  const [nowEditTrade, setNowEditTrade] = useState([]);

  /* カテゴリ */
  const categoryOptions = [
    { key: "a00", value: "", text: "-" },
    { key: "a01", value: "人件費(イントラ)", text: "人件費(イントラ)" },
    { key: "a02", value: "人件費(社員)", text: "人件費(社員)" },
    { key: "a03", value: "レンタルスタジオ", text: "レンタルスタジオ" },
    { key: "a04", value: "家賃", text: "家賃" },
    { key: "a05", value: "雑費", text: "雑費" },
    { key: "a06", value: "広告宣伝費", text: "広告宣伝費" },
    { key: "a07", value: "交通費", text: "交通費" },
    { key: "a08", value: "開発費", text: "開発費" },
    { key: "a09", value: "備品", text: "備品" },
    { key: "a10", value: "衣装", text: "衣装" },
    { key: "a11", value: "交際費", text: "交際費" },
    { key: "a12", value: "福利厚生費", text: "福利厚生費" },
    { key: "a13", value: "保険", text: "保険" },
    { key: "a14", value: "手数料", text: "手数料" },
    { key: "a15", value: "光熱費", text: "光熱費" },
    { key: "a16", value: "人件費", text: "人件費" },
    { key: "a17", value: "郵送料", text: "郵送料" },
    { key: "a18", value: "不明", text: "不明" },
  ];
  /* 決済手段 */
  const paymentOptions = [
    { key: "b00", value: "", text: "-" },
    { key: "b01", value: "振込", text: "振込" },
    { key: "b02", value: "クレジット", text: "クレジット" },
    { key: "b03", value: "現金", text: "現金" },
  ];

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;

    setActiveIndex(newIndex);
  };

  // フィルターのチェックボックスをstateに保存
  const handleCheckboxChange = (filterState) => (event) => {
    const { checked } = event.target;
    const labelText = event.target.nextSibling.textContent;

    filterState((prev) => {
      if (checked) {
        return [...prev, labelText];
      } else {
        return prev.filter((item) => item !== labelText);
      }
    });
  };

  // ソートの状態を更新する関数
  const handleSort = (setSortFunction, currentValue, order) => {
    // 現在の値がすでに設定された順序（'昇順'など）と同じ場合、空文字を設定してリセット
    const nextValue = currentValue === order ? "" : order;
    setSortFunction(nextValue);
  };

  // 取引履歴の更新、削除
  const updateDeleteTrades = async () => {
    setLoadingStatus(true);
    // editedTradesオブジェクトを配列に変換
    const tradesArray = Object.values(editedTrades);
    if (tradesArray.length === 0) {
      setLoadingStatus(false);
      return;
    }
    // 配列にユーザーID追加
    tradesArray.forEach(function (item) {
      item.user_id = userId;
    });

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/api/update_delete_trade/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(tradesArray),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // 最新の取引情報を取得
      setEditedTrades({});
      fetchFilterSort();
      fetchTradeLogs();
      fetchCompanies();

      const result = await response.json();
      setLoadingStatus(false);
      alert("取引履歴を更新しました");
    } catch (error) {
      setLoadingStatus(false);
      alert("取引履歴の更新に失敗しました");
      console.error("There was a problem with the fetch operation:", error);
    }
  };

  // 取引履歴の変更
  const handleTradeChange = (index, field, value) => {
    setEditedTrades((prev) => {
      const updatedTrades = { ...prev };
      if (!updatedTrades[index]) {
        updatedTrades[index] = { ...trades[index] };
      }
      updatedTrades[index][field] = value;
      return updatedTrades;
    });
  };

  // ログデータ取得
  const fetchTradeLogs = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/api/get_trade_logs/`, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const logs = await response.json();
      setLogs(logs);
    } catch (error) {
      console.error("ログデータの取得に失敗しました:", error);
    }
  };

  // 取引先リスト取得
  const fetchCompanies = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/api/get_companies/`, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const companies = await response.json();
      setCompanies(companies);
    } catch (error) {
      console.error("ログデータの取得に失敗しました:", error);
    }
  };

  // 取引先検索のボタン押下時のハンドル
  const handleFilteredCompanyButtonClick = async (name) => {
    await setCounterpartyFromButton(name);
    setFilteredCompanyNames([]);
  };
  const setCounterpartyFromButton = async (name) => {
    setCounterparty(name);
  };

  // 取引リスト取得（フィルターとソート）
  const fetchFilterSort = async () => {
    const filterData = {
      is_superuser: localStorage.getItem("isSuperuser"),
      date_start: startDateFilter,
      date_end: endDateFilter,
      counterparty: counterpartyFilter,
      amount: amountFilter,
      category: categoryFilter,
      payment_method: paymentMethodFilter,
      trade_id: tradeIdFilter,
      date_sort: dateSort,
      amount_sort: amountSort,
      settlement_date_sort: settlementSort,
      trade_id_sort: tradeIdSort,
      page: page,
      counterparty_sort: counterpartySort,
    };

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(
        `${apiUrl}/api/get_filtered_sorted_trades/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(filterData),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const trades = await response.json();
      if (page === 1) {
        // ページが1の場合は新規追加
        setTrades(trades);
      } else {
        // ページが1でない場合は追加
        setTrades((prevs) => {
          const newTrades = trades.filter(
            (newTrade) => !prevs.some((prev) => prev.id === newTrade.id)
          );
          return [...prevs, ...newTrades];
        });
      }
    } catch (error) {
      alert("登録に失敗しました");
      console.error("There was a problem with the fetch operation:", error);
    }
  };

  // ログと取引先リストと重複リスト取得
  useEffect(() => {
    fetchTradeLogs();
    fetchCompanies();
    fetchDuplicateTrades();
  }, []);

  // 画面下部までスクロールしたらページ数を＋１
  useEffect(() => {
    const handleScroll = () => {
      const isBottom =
        window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight;
      if (isBottom) {
        setPage(page + 1);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [page]);

  // 取引先リストの絞り込み
  useEffect(() => {
    // 検索テキストが空の場合はフィルタリングしない
    if (!counterparty) {
      setFilteredCompanyNames([]);
      return;
    }

    // 検索処理
    const filtered = companies
      .filter(
        (company) =>
          company.name.includes(counterparty) ||
          company.kana.includes(counterparty) ||
          company.alphabet.includes(counterparty)
      )
      .map((filteredCompany) => filteredCompany.name);

    setFilteredCompanyNames(filtered);
  }, [counterparty]);

  // ページが既に1の場合は帳簿リスト取得。1以外の場合は1にリセット
  useEffect(() => {
    if (page === 1) {
      fetchFilterSort();
    }
    setPage(1);
  }, [
    startDateFilter,
    endDateFilter,
    counterpartyFilter,
    amountFilter,
    categoryFilter,
    paymentMethodFilter,
    tradeIdFilter,
    dateSort,
    amountSort,
    settlementSort,
    tradeIdSort,
    counterpartySort,
  ]);

  // ページが変更されたら帳簿リストを取得
  useEffect(() => {
    fetchFilterSort();
  }, [page]);

  // 表示非表示
  const [showCheatSheet, setShowCheatSheet] = useState(false);
  const handleCheatSheetToggle = () => {
    setShowCheatSheet(!showCheatSheet);
  };

  // まるばつ切り替え
  const [duplicateProcessedList, setDuplicateProcessedList] = useState({});

  // 重複リストの取得
  const fetchDuplicateTrades = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/api/get_duplicate_trades/`, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const duplicate = await response.json();
      setDuplicateTrades(duplicate);
    } catch (error) {
      console.error("ログデータの取得に失敗しました:", error);
    }
  };

  // 重複リストを押下した際の処理
  const handleDuplicateClick = (id) => {
    setDuplicateProcessedList((prevList) => {
      // 既存の状態を取得
      const currentStatus = prevList[id];
      let newStatus;
      if (currentStatus === undefined) {
        // 初期状態（" "）から"✖️"へ
        newStatus = false;
      } else if (currentStatus === false) {
        // "✖️"から"⭕️" へ
        newStatus = true;
      } else {
        // "✖️"から" "へ（リストから削除）
        newStatus = undefined;
      }

      // 新しい状態を設定
      if (newStatus === undefined) {
        const { [id]: _, ...newList } = prevList;
        return newList;
      } else {
        return { ...prevList, [id]: newStatus };
      }
    });
  };

  // 重複を削除
  const handleRemoveDuplicates = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/api/remove_duplicates/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(duplicateProcessedList),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      alert("重複を削除しました:");
      // duplicateProcessedListをリセット
      setDuplicateProcessedList({});
      // duplicateTradesをフェッチしなおす
      await fetchDuplicateTrades();
    } catch (error) {
      alert("重複の削除に失敗しました:", error);
    }
  };

  useEffect(() => {
    console.log(editedTrades);
  }, [editedTrades]);

  return (
    <>
    {/* ローディング */}
    <Dimmer active={loadingStatus}>
      <Loader size="large" />
    </Dimmer>
    <div className="gridColumn">
      <Container style={{ padding: "30px 0" }}>
        {/* 入力 */}
        <TabComponent
          logs={logs}
          setLoadingStatus={setLoadingStatus}
          fetchTradeLogs={fetchTradeLogs}
          categoryOptions={categoryOptions}
          paymentOptions={paymentOptions}
          counterparty={counterparty}
          setCounterparty={setCounterparty}
          fetchFilterSort={fetchFilterSort}
          fetchCompanies={fetchCompanies}
        />

        {/* フィルター・ソート */}
        <Accordion>
          <AccordionTitle
            active={activeIndex === 0}
            index={0}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            フィルター
          </AccordionTitle>
          <AccordionContent active={activeIndex === 0}>
            <div className="sort">
              <Grid>
                <GridColumn width={10}>
                  <Segment>
                    <Label attached="top left">フィルター</Label>
                    <Grid className="aaaaaa" style={{ width: "100%" }}>
                      <GridColumn width={16}>
                        <Grid>
                          <GridColumn width={8} className="mini">
                            {/* 期間 */}
                            <Grid>
                              <GridColumn width={8} className="mini">
                                <p>日付</p>
                                <div className="date-layout">
                                  <Form size="mini">
                                    <Input
                                      type="date"
                                      value={startDateFilter}
                                      onChange={(e) =>
                                        setStartDateFilter(e.target.value)
                                      }
                                    />
                                  </Form>
                                  <p>~</p>
                                  <Form size="mini">
                                    <Input
                                      type="date"
                                      value={endDateFilter}
                                      onChange={(e) =>
                                        setEndDateFilter(e.target.value)
                                      }
                                    />
                                  </Form>
                                </div>
                              </GridColumn>
                            </Grid>
                          </GridColumn>
                          <GridColumn width={4} className="mini">
                            {/* 取引先 */}
                            <Grid>
                              <GridColumn width={16} className="mini">
                                <p>取引先</p>
                                <Search
                                  input={{
                                    icon: "search",
                                    iconPosition: "left",
                                    style: { width: "100%" },
                                  }}
                                  placeholder="テキストで検索"
                                  onSearchChange={(e) =>
                                    setCounterpartyFilter(e.target.value)
                                  }
                                />
                              </GridColumn>
                            </Grid>
                          </GridColumn>

                          {/* 金額 */}
                          <GridColumn width={4} className="mini">
                            <p>金額</p>
                            <Search
                              input={{
                                icon: "yen",
                                iconPosition: "left",
                                style: { width: "100%" },
                              }}
                              placeholder="テキストで検索"
                              onSearchChange={(e) =>
                                setAmountFilter(e.target.value)
                              }
                            />
                          </GridColumn>

                          {/* ID */}
                          <GridColumn width={4} className="mini">
                            <p>ID</p>
                            <Search
                              input={{
                                icon: "search",
                                iconPosition: "left",
                                style: { width: "100%" },
                              }}
                              placeholder="テキストで検索"
                              onSearchChange={(e) =>
                                setTradeIdFilter(e.target.value)
                              }
                            />
                          </GridColumn>
                        </Grid>
                        <Grid>
                          {/* カテゴリ */}
                          <GridColumn width={8} className="check mini">
                            <p>カテゴリ</p>
                            <ul>
                              {categoryOptions
                                // 空の値（"-"）を除外
                                .filter((option) => option.value !== "")
                                .map((option) => ({
                                  id: option.key,
                                  text: option.text,
                                }))
                                .map((category) => (
                                  <li key={category.id}>
                                    <input
                                      id={category.id}
                                      type="checkbox"
                                      onChange={handleCheckboxChange(
                                        setCategoryFilter
                                      )}
                                      checked={categoryFilter.includes(
                                        category.text
                                      )}
                                    />
                                    <label
                                      htmlFor={category.id}
                                      className={
                                        categoryFilter.includes(category.text)
                                          ? "on"
                                          : ""
                                      }
                                    >
                                      {category.text}
                                    </label>
                                  </li>
                                ))}
                            </ul>
                          </GridColumn>
                          {/* 決済手段 */}
                          <GridColumn width={8} className="check mini">
                            <p>決済手段</p>
                            <ul>
                              {paymentOptions
                                // 空の値（"-"）を除外
                                .filter((option) => option.value !== "")
                                .map((option) => ({
                                  id: option.key,
                                  text: option.text,
                                }))
                                .map((paymentMethod) => (
                                  <li key={paymentMethod.id}>
                                    <input
                                      id={paymentMethod.id}
                                      type="checkbox"
                                      onChange={handleCheckboxChange(
                                        setPaymentMethodFilter
                                      )}
                                      checked={paymentMethodFilter.includes(
                                        paymentMethod.text
                                      )}
                                    />
                                    <label
                                      htmlFor={paymentMethod.id}
                                      className={
                                        paymentMethodFilter.includes(
                                          paymentMethod.text
                                        )
                                          ? "on"
                                          : ""
                                      }
                                    >
                                      {paymentMethod.text}
                                    </label>
                                  </li>
                                ))}
                            </ul>
                          </GridColumn>
                        </Grid>
                      </GridColumn>
                    </Grid>
                  </Segment>
                </GridColumn>

                <GridColumn width={6}>
                  <Segment>
                    <Label attached="top left">ソート</Label>
                    <Grid>
                      <GridRow style={{ rowGap: "10px" }}>
                        {/* 取引先で並び替え */}
                        <GridColumn width={3} className="nowrap">
                          <p className="mini">取引先</p>
                        </GridColumn>
                        <GridColumn width={5} className="nowrap">
                          <ButtonGroup>
                            <Button
                              className="mini"
                              onClick={() =>
                                handleSort(
                                  setCounterpartySort,
                                  counterpartySort,
                                  "昇順"
                                )
                              }
                              active={counterpartySort === "昇順"}
                            >
                              昇順
                            </Button>
                            <Button
                              className="mini"
                              onClick={() =>
                                handleSort(
                                  setCounterpartySort,
                                  counterpartySort,
                                  "降順"
                                )
                              }
                              active={counterpartySort === "降順"}
                            >
                              降順
                            </Button>
                          </ButtonGroup>
                        </GridColumn>
                        <GridColumn width={3} className="nowrap">
                          <p className="mini">日付</p>
                        </GridColumn>
                        <GridColumn width={5} className="nowrap">
                          <ButtonGroup>
                            <Button
                              className="mini"
                              onClick={() =>
                                handleSort(setDateSort, dateSort, "昇順")
                              }
                              active={dateSort === "昇順"}
                            >
                              昇順
                            </Button>
                            <Button
                              className="mini"
                              onClick={() =>
                                handleSort(setDateSort, dateSort, "降順")
                              }
                              active={dateSort === "降順"}
                            >
                              降順
                            </Button>
                          </ButtonGroup>
                        </GridColumn>
                        <GridColumn width={3} className="nowrap">
                          <p className="mini">金額</p>
                        </GridColumn>
                        <GridColumn width={5} className="nowrap">
                          <ButtonGroup>
                            <Button
                              className="mini"
                              onClick={() =>
                                handleSort(setAmountSort, amountSort, "昇順")
                              }
                              active={amountSort === "昇順"}
                            >
                              昇順
                            </Button>
                            <Button
                              className="mini"
                              onClick={() =>
                                handleSort(setAmountSort, amountSort, "降順")
                              }
                              active={amountSort === "降順"}
                            >
                              降順
                            </Button>
                          </ButtonGroup>
                        </GridColumn>
                        <GridColumn width={3} className="nowrap">
                          <p className="mini">立替精算</p>
                        </GridColumn>
                        <GridColumn width={5} className="nowrap">
                          <ButtonGroup>
                            <Button
                              className="mini"
                              onClick={() =>
                                handleSort(
                                  setSettlementSort,
                                  settlementSort,
                                  "昇順"
                                )
                              }
                              active={settlementSort === "昇順"}
                            >
                              昇順
                            </Button>
                            <Button
                              className="mini"
                              onClick={() =>
                                handleSort(
                                  setSettlementSort,
                                  settlementSort,
                                  "降順"
                                )
                              }
                              active={settlementSort === "降順"}
                            >
                              降順
                            </Button>
                          </ButtonGroup>
                        </GridColumn>
                        <GridColumn width={3} className="nowrap">
                          <p className="mini"> ID</p>
                        </GridColumn>
                        <GridColumn width={5} className="nowrap">
                          <ButtonGroup>
                            <Button
                              className="mini"
                              onClick={() =>
                                handleSort(setTradeIdSort, tradeIdSort, "昇順")
                              }
                              active={settlementSort === "昇順"}
                            >
                              昇順
                            </Button>
                            <Button
                              className="mini"
                              onClick={() =>
                                handleSort(setTradeIdSort, tradeIdSort, "降順")
                              }
                              active={settlementSort === "降順"}
                            >
                              降順
                            </Button>
                          </ButtonGroup>
                        </GridColumn>
                      </GridRow>
                    </Grid>
                  </Segment>
                </GridColumn>
              </Grid>
            </div>
          </AccordionContent>
        </Accordion>

        {/***************************/}
        {/* 一覧 */}
        {/***************************/}
        {/* タイトル */}
        <div className="tradeWrap">
          <div className="tradeList ttl">
            <div>
              <p className="">ID</p>
            </div>
            <div>
              <p className="">日付</p>
            </div>
            <div>
              <p className="">取引先</p>
            </div>
            <div>
              <p className="">金額</p>
            </div>
            <div>
              <p className="">カテゴリ</p>
            </div>
            <div>
              <p className="">決済手段</p>
            </div>
            <div>
              <p className="">立替精算</p>
            </div>
            <div>
              <p className="">画像</p>
            </div>
            <div>
              <p className="">削除</p>
            </div>
          </div>

          {/* 取引履歴 */}
          {trades
            .filter((trade) => !trade.delete_flg)
            .map((trade, index) => {
              return (
                <>
                  {trade.id !== nowEditTrade.id && (
                    <div
                      key={trade.id}
                      className={`tradeWrap revert${index}`}
                      onClick={() => {
                        setNowEditTrade(trade);
                      }}
                    >
                      <div className="tradeList">
                        <div>{trade.id}</div>
                        <div>
                          {/* 日付 */}
                          <p size="mini">
                            <div>
                              {editedTrades[index]?.date !== undefined
                                ? editedTrades[index]?.date
                                : trade.date}
                            </div>
                          </p>
                        </div>
                        <div>
                          {/* 取引先 */}
                          <p size="mini">
                            <div>
                              {editedTrades[index]?.counterparty !== undefined
                                ? editedTrades[index]?.counterparty
                                : trade.counterparty}
                            </div>
                          </p>
                        </div>
                        <div>
                          <p size="mini">
                            <div>
                              {editedTrades[index]?.amount !== undefined
                                ? editedTrades[index]?.amount
                                : trade.amount}
                            </div>
                          </p>
                        </div>
                        {/* カテゴリ */}
                        <div>
                          <p size="mini">
                            <div>
                              {editedTrades[index]?.category !== undefined
                                ? editedTrades[index]?.category
                                : trade.category}
                            </div>
                          </p>
                        </div>
                        {/* 決済手段 */}
                        <div>
                          <p size="mini">
                            <div>
                              {editedTrades[index]?.payment_method !== undefined
                                ? editedTrades[index]?.payment_method
                                : trade.payment_method}
                            </div>
                          </p>
                        </div>
                        {/* 立替精算 */}
                        <div>
                          <p size="mini">
                            <div>
                              {editedTrades[index]?.settlement_date !==
                              undefined
                                ? editedTrades[index]?.settlement_date
                                : trade.settlement_date}
                            </div>
                          </p>
                        </div>
                        {/* 画像 */}
                        <div className="center">
                          {trade.image_url && (
                            <a
                              key={trade.id}
                              href={trade.image_url}
                              data-lightbox={trade.id}
                            >
                              <IconImage />
                            </a>
                          )}
                        </div>
                        {/* 削除 */}
                        <div>
                          <div className="flex-center">
                            <Checkbox
                              checked={
                                editedTrades[index]?.delete_flg ||
                                trade.delete_flg
                              }
                              onChange={(e, data) =>
                                handleTradeChange(
                                  index,
                                  "delete_flg",
                                  data.checked
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {trade.id === nowEditTrade.id && (
                    <div className={`tradeWrap nowedit${index}`}>
                      <InputComponent
                        nowEditTrade={nowEditTrade}
                        handleTradeChange={handleTradeChange}
                        index={index}
                        editedTrades={editedTrades}
                        categoryOptions={categoryOptions}
                        paymentOptions={paymentOptions}
                      />
                    </div>
                  )}
                </>
              );
            })}
        </div>

        <footer style={showCheatSheet ? {} : { backdropFilter: "blur(0px)" }}>
          <div>
            <div width={12} className="cheatSheet">
              {/* チートシート */}
              {showCheatSheet && <MenuExampleTabularOnLeft />}
            </div>

            <div className="flex">
              {/*  */}
              <Button yellow onClick={handleCheatSheetToggle}>
                チートシート
              </Button>
              {/*  */}
              <Button primary onClick={updateDeleteTrades}>
                帳簿を保存
              </Button>
            </div>
          </div>

          <div className="flex">
            {/*  */}
            <Button primary onClick={handleRemoveDuplicates}>
              重複を削除
            </Button>
          </div>
        </footer>

        <Container
          className={
            filteredCompanyNames.length > 0 ? "yomiBox on" : "yomiBox off"
          }
        >
          <Segment>
            <p className="mini">取引先検索</p>
            <ul className="corpWords">
              {filteredCompanyNames.map((name, index) => (
                <Button
                  className="mini"
                  key={index}
                  onClick={() => handleFilteredCompanyButtonClick(name)}
                >
                  {name}
                </Button>
              ))}
            </ul>
          </Segment>
        </Container>
      </Container>
      <div className="duplicate">
        {/* 重複リスト */}
        <h2>重複リスト</h2>
        {/* アイテム */}
        {duplicateTrades.map((duplicateTrade, index) => (
          <ul key={index}>
            {duplicateTrade.map((data) => (
              <li
                key={data.id}
                onClick={(event) => {
                  if (event.target.tagName !== "A") {
                    handleDuplicateClick(data.id);
                  }
                }}
              >
                {/*  */}
                <div
                  className={`item type2 ${
                    duplicateProcessedList[data.id] === true
                      ? "on"
                      : duplicateProcessedList[data.id] === false
                      ? "off"
                      : ""
                  }`}
                >
                  <p>
                    {duplicateProcessedList[data.id] === true
                      ? "⭕️"
                      : duplicateProcessedList[data.id] === false
                      ? "✖️"
                      : " "}
                  </p>
                  <p>{data.date}</p>
                  <p>{data.counterparty}</p>
                  <p>{data.amount}</p>
                  <p>{data.payment_method}</p>
                  <p>{data.settlement_date}</p>
                  {data.image_url && (
                    <a
                      key={data.id}
                      href={data.image_url}
                      data-lightbox={index}
                    >
                      <IconImage />
                    </a>
                  )}
                </div>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
    </>
  );
}

export default TradePage;
